import { render, staticRenderFns } from "./intro_2.vue?vue&type=template&id=ee2fd78e&scoped=true&"
var script = {}
import style0 from "./intro_2.vue?vue&type=style&index=0&id=ee2fd78e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2fd78e",
  null
  
)

export default component.exports